import React, { useState, useRef, useEffect } from "react";
import { useQuery } from "react-query";
import { DataTable } from "primereact/datatable";
import authApi from "../../../service/IdApi";
import PageLoadError from "../../../components/PageLoadError";
import PageHeading from "../../../components/PageHeading";
import { Column } from "primereact/column";
import { Button } from 'primereact/button';
import { Link, useLocation } from "react-router-dom";
import LazyState from "../../../utils/LazyState";
import { AutoComplete } from "primereact/autocomplete";
import { throttle } from "lodash";

const ProviderEventLog = () => {
    const location = useLocation();
    const [logs, setLogs] = useState(null);
    const dataTable = useRef(null);
    const [totalRecords, setTotalRecords] = useState(0);
    const [loaded, setLoaded] = useState(false);
    const [timer, setTimer] = useState(null);
    const [lazyState, setLazyState] = useState(() => {
        if (location.state && location.state.lazyState) {
            return location.state.lazyState;
        }
        return {
            first: 0,
            rows: 25,
            page: 1,
            sortField: "cAt",
            sortOrder: -1
        };
    });
    const [provider, setProvider] = useState('');
    const [providers, setProviders] = useState([]);

    const { isLoading, isFetching, isError, data, refetch } = useQuery(["ProviderLogs", lazyState], async () => {
        if (!provider) {
            setLoaded(true);
            return;
        }
        // const usersResult = await idApi.get('auth/provider/users');
        // let _allUsers = usersResult.data.users;
        // setAllUsers(_allUsers);
        var isFiltering = false;
        var body = {};
        body.first = lazyState.first;
        if (lazyState.first !== 0) {
            isFiltering = true;
        }
        body.rows = lazyState.rows;
        body.sortField = lazyState.sortField;
        body.sortOrder = lazyState.sortOrder;
        body.type = [];
        body.providerId = provider._id;
        const result = await authApi.post("admin/provider-log-activity", body);
        // if (result.data.logs.length > 0) {
        //     result.data.logs = result.data.logs.map(log => {
        //         if (log.userType === 'pu') {
        //             // This is a Provider User
        //             const matchingUser = _allUsers.find(user => user._id === log.createdBy);
        //             if (matchingUser) {
        //                 log.email = matchingUser.email;
        //             } else {
        //                 log.email = "[No longer exists]";
        //             }
        //         }
        //         return log;
        //     });
        // }
        setLogs(result.data.logs);
        setTotalRecords(result.data.totalRecords);
        setLoaded(true);
        return data;
    });

    useEffect(() => {
        return () => {
            if (timer) {
                clearTimeout(timer);
            }
        };
    }, [timer]);

    const searchProviders = throttle(async (e) => {
        var searchBody = {};
        searchBody.first = 0;
        searchBody.rows = 10;
        searchBody.sortField = "name";
        searchBody.sortOrder = 1;
        searchBody.name = e.query;
        const result = await authApi.post("admin/provider/list", searchBody);
        setProviders(result.data.providers);
    }, 500, { trailing: false });

    const pageHeader = (
        <PageHeading pageTitle="Admin - Provider Activity Log">
            <div className="block">
            </div>
        </PageHeading>
    );

    if (isError) {
        return (
            <div>
                {pageHeader}
                <PageLoadError />
            </div>
        );
    }

    const onPage = (event) => {
        setLazyState(event);
    };

    const onSort = (event) => {
        setLazyState(event);
    };

    const nameBodyTemplate = (rowData) => {
        return <>{rowData.eventName}</>;
    };

    const userTypeBodyTemplate = (rowData) => {
        if (rowData.userType === "pu") {
            return <span>Provider User</span>;
        }
        else if (rowData.userType === "wa") {
            return <span>Wallist Admin</span>;
        }
        else if (rowData.userType === "pc") {
            return <span>Provider Client</span>;
        }
        else if (rowData.userType === "eu") {
            return <span>End User</span>;
        }
        else if (rowData.userType === "sys") {
            return <span>System</span>;
        }
        return <>{rowData.userType}</>;
    };

    const statusBodyTemplate = (rowData) => {
        if (rowData.eventStatus === "s") {
            return <span>Success</span>;
        }
        else if (rowData.eventStatus === "f") {
            return <span>Error</span>;
        }
    };

    const messageBodyTemplate = (rowData) => {
        return <div style={{ whiteSpace: 'pre-wrap' }}>{rowData.message}</div>;
    };

    const exceptionBodyTemplate = (rowData) => {
        return <>{rowData.exception}</>;
    };

    const createdAtBodyTemplate = (rowData) => {
        return <>{rowData.createdAt}</>;
    };

    const createdByBodyTemplate = (rowData) => {
        return <>{rowData.email}</>;
    };

    const artifactBodyTemplate = (rowData) => {
        const host = process.env.REACT_APP_PROVIDER_SITE;
        if (rowData.artifactNumber) {
            if (rowData.artifactType === "c") {
                return <a href={`${host}/provider/${provider.providerNumber}/clients/view/${rowData.artifactNumber}`} target="_blank">Client {rowData.artifactNumber}</a>;
            }
            else if (rowData.artifactType === "i") {
                return <a href={`${host}/provider/${provider.providerNumber}/invoices/view/${rowData.artifactNumber}`} target="_blank">Invoice {rowData.artifactNumber}</a>;
            }
            else if (rowData.artifactType === "e") {
                return <a href={`${host}/provider/${provider.providerNumber}/estimates/view/${rowData.artifactNumber}`} target="_blank">Estimate {rowData.artifactNumber}</a>;
            }
            else if (rowData.artifactType === "r") {
                return <a href={`${host}/provider/${provider.providerNumber}/requests/view/${rowData.artifactNumber}`} target="_blank">Request {rowData.artifactNumber}</a>;
            }
            else if (rowData.artifactType === "p") {
                return <a href={`${host}/provider/${provider.providerNumber}/price-books/view/${rowData.artifactNumber}`} target="_blank">Price Book {rowData.artifactNumber}</a>;
            }
            else if (rowData.artifactType === "t") {
                return <a href={`${host}/provider/${provider.providerNumber}/tax-rates/view/${rowData.artifactNumber}`} target="_blank">Tax Rate {rowData.artifactNumber}</a>;
            }
            else if (rowData.artifactType === "j") {
                return <a href={`${host}/provider/${provider.providerNumber}/jobs/view/${rowData.artifactNumber}`} target="_blank">Job {rowData.artifactNumber}</a>;
            }
            else if (rowData.artifactType === "s") {
                return <a href={`${host}/provider/${provider.providerNumber}/subscriptions/view/${rowData.artifactNumber}`} target="_blank">Subscription {rowData.artifactNumber}</a>;
            }
            else {
                return <>{rowData.artifactNumber}</>;
            }
        }
        else {
            return <></>;
        }
    };

    const clearFilter = () => {
        setProvider('');
        setLazyState(LazyState.resetLazyState(lazyState));
    }

    const providerChanged = (e) => {
        setProvider(e.value);
    }

    const providerSelected = (e) => {
        setProvider(e.value);
        setLazyState(LazyState.resetLazyState(lazyState));
    }

    return (
        <div>
            {pageHeader}
            <div className="layout-content">
                <div className="card pt-3 sm:pt-0">
                    <div className="flex pt-3 w-full">
                        <div className="flex flex-row text-lg align-items-center mb-2">
                            Enter the company name to search for provider logs.
                        </div>
                        <div className="flex flex-row flex-grow-1 justify-content-end">
                        </div>
                    </div>
                    <div className="flex flex-row flex-wrap mb-2">
                        <div className="flex align-items-center mr-2">
                            Filter By
                        </div>
                        <div>
                            <AutoComplete forceSelection field="name" value={provider} suggestions={providers} completeMethod={searchProviders} onChange={providerChanged} onSelect={providerSelected} placeholder="Provider Name" />
                        </div>
                        {provider && (
                            <>
                                <div className="flex align-items-center mr-2">
                                    <Button onClick={clearFilter} className="p-button-text" icon="pi pi-times" tooltip="Clear Filter" />
                                </div>
                                <div className="flex align-items-center mr-2">
                                    <Button onClick={refetch} className="p-button-text" icon="pi pi-refresh" tooltip="Refresh Logs" />
                                </div>
                            </>
                        )}
                    </div>
                    <DataTable
                        ref={dataTable}
                        value={logs}
                        dataKey="itemNumber"
                        paginator
                        rows={lazyState.rows}
                        rowsPerPageOptions={[10, 25, 50, 100]}
                        className="datatable-responsive"
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} items"
                        emptyMessage="No logs found"
                        lazy
                        first={lazyState.first}
                        totalRecords={totalRecords}
                        onPage={onPage}
                        onSort={onSort}
                        sortField={lazyState.sortField}
                        sortOrder={lazyState.sortOrder}
                        loading={isLoading || isFetching || !loaded}
                        size="small"
                    >
                        <Column field="cAt" header="Date" sortable body={createdAtBodyTemplate} />
                        <Column field="uType" header="User Type" sortable body={userTypeBodyTemplate} />
                        <Column field="cBy" header="User" sortable body={createdByBodyTemplate} />
                        <Column field="eName" header="Event" sortable body={nameBodyTemplate} />
                        <Column field="aN" header="Reference" sortable body={artifactBodyTemplate} />
                        <Column field="eStatus" header="Status" sortable body={statusBodyTemplate} />
                        <Column field="msg" header="Message" sortable body={messageBodyTemplate} />
                        <Column field="exc" header="Exception" sortable body={exceptionBodyTemplate} />
                    </DataTable>
                </div>
            </div>
        </div>
    );
};

export default ProviderEventLog;
